import React from 'react'

export default function DashboardNotes() {

    return (
        <div className='dashboard-notes'>
            <p>* Trade volume data - Trade volumes are sourced from PIERS and the U.S. Commerce Department (FY2023), and the counties are based on the location of the company on the bill of lading and are not necessarily the origin/destination of the cargo. Ports of Savannah and Brunswick include private terminals. Tons reflects all trade, both container and non-container, while TEUs reflects only container trade.</p>
            <p>** Economic Impact data source: Terry College of Business, University of Georgia (FY2023)</p>
        </div>
    )

}